/**
 * Environment configuration for the Interview Builder frontend
 *
 * VITE_INTERVIEWER_URL values per environment (AS-1812 — canonical
 * hostnames moved from `.upwage.net` to `.upwage.io`; legacy hostnames
 * remain served by the same CloudFront for the migration window):
 *   - Local:   http://localhost:3006
 *   - Staging: https://interview-staging.upwage.io
 *   - Preprod: https://interview-preprod.upwage.io
 *   - Prod:    https://interview.upwage.io
 */

export const envConfig = {
  apiUrl: import.meta.env.VITE_API_URL || "http://localhost/screener",
  appEnv: import.meta.env.VITE_APP_ENV || "development",
  interviewerUrl:
    import.meta.env.VITE_INTERVIEWER_URL || "http://localhost:3006",
};
